import { createSlice } from '@reduxjs/toolkit';

import { loadPurchasePlansItem, loadPurchasePlansList } from './actions';
import { PurchasePlansState } from './interfaces';

export const purchasePlansSlice = createSlice({
  name: 'purchasePlans',
  initialState: {
    list: [],
    item: null,
    limit: 20,
    total: 0,
    offset: 0,
  } as PurchasePlansState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadPurchasePlansList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
      }
    );
    builder.addCase(loadPurchasePlansItem.fulfilled, (state, { payload }) => {
      state.item = payload;
    });
  },
});
